import React from 'react';
import { Link } from 'react-router-dom';

export default function Error404() {
  return (
    <div className="flex lg:flex-row flex-col justify-center items-center h-screen text-greenish dark:text-beige text-lg py-4 px-2">
      <img
        src="https://media.discordapp.net/attachments/1054797763348541583/1075137566464028743/404-Error-with-a-cute-animal-rafiki.png"
        alt="Page Not Found"
        className=" w-auto"
      />
      <p>
        Opps! Seems like you got lost.
        <br />
        Click{' '}
        <Link to="/" className="underline font-semibold">
          here
        </Link>{' '}
        to get back on track!
      </p>
    </div>
  );
}
